import { render, staticRenderFns } from "./MenuLayerParamsParticlesDialog.vue?vue&type=template&id=04a792d5&"
import script from "./MenuLayerParamsParticlesDialog.vue?vue&type=script&lang=js&"
export * from "./MenuLayerParamsParticlesDialog.vue?vue&type=script&lang=js&"
import style0 from "./MenuLayerParamsParticlesDialog.vue?vue&type=style&index=0&id=04a792d5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports